/* eslint-disable no-undef */

import React                           from 'react'
import { Row, Col, Container }         from 'react-grid-system'
import { Tabs, message, notification } from 'antd'

import { bindActionCreators } from 'redux'
import { withRouter }         from 'react-router-dom'
import { connect }            from 'react-redux'

import { refresh_profile } from '../../actions/auth'
import CloudFlyerAPI          from '../../api/CloudFlyerAPI'
import LocalFiles          from '../../components/FileCatalyst/Local/files-system'
import CloudFilesSystem    from '../../components/Fs/Cloud/files-system'
import FilesTransfers      from '../../components/FileCatalyst/Transfers/files-transfers'

import Last24              from '../../components/FileCatalyst/History/last-24'
import ThisMonth           from '../../components/FileCatalyst/History/this-month'
import LastMonth           from '../../components/FileCatalyst/History/last-month'
import TransfersHistory    from '../../components/FileCatalyst/History/transfers'

import UploadSize          from '../../components/FileCatalyst/Indicators/upload-size'
import CostPerMb           from '../../components/FileCatalyst/Indicators/cost-per-mb'
import UploadCost          from '../../components/FileCatalyst/Indicators/upload-cost'
import AccessControl       from '../../components/S3Direct/Indicators/access-control'
import DownloadSize        from '../../components/FileCatalyst/Indicators/download-size'
import DownloadCost        from '../../components/FileCatalyst/Indicators/download-cost'
import Launcher            from '../../components/FileCatalyst/Indicators/launcher'

import './index.scss'

class FileCatalyst extends React.Component {

  constructor (props) {
    super(props)
    this.state = {
      history:{
        last_24 : {
          count : 0,
          size : 0,
          cost: 0.00
        },

        this_month : {
          count : 0,
          size : 0,
          cost: 0.00
        },

        last_month : {
          count : 0,
          size : 0,
          cost: 0.00
        }
      },

      access_control  : 'private',
      s3Acceleration  : false,

      upload_selection : {
        size       : 0,
        cost       : 0.0003,
        total_cost : 0,
        count      : 0
      },

      download_selection : {
        size       : 0,
        cost       : 0.0003,
        total_cost : 0,
        count      : 0
      },

      connection_key : null,
      launch_attempt : 0,

      launch_loading     : false,
      transfer_loading   : false,

      last_24_loading    : false,
      this_month_loading : false,
      last_month_loading : false,

      is_transfer_agent_running: false,
      transfer_server_error : null,
      heartbeat : 5000
    }
  }

  componentDidMount() {
    this.heartbeat(0)
    this.update_metrics()
  }

  componentWillReceiveProps(props) {
    this.setState({
      upload_selection   : props.upload_selection ? props.upload_selection : this.state.upload_selection,
      download_selection : props.download_selection ? props.download_selection : this.state.download_selection
    })
  }

  on_download (cloud_account_id, bucket_name, file_names) {
    let $this = this

    if(!this.state.is_transfer_agent_running){
      return message.warn('Please launch the transfer agent before trying upload!')
    }

    if(this.state.transfer_server_error){
      return notification.warn('Error connecting to the transfer server')
    }

    $this.setState({transfer_loading : true})

    CloudFlyerAPI
      .file_catalyst
      .transfers
      .download(file_names.map((f)=> '/' + bucket_name + '/' + f),
        $this.props.local_current_path,
        $this.state.connection_key,
        $this.props.user.id)
      .then(res =>{
        $this.setState({
          transfer_loading : false
        })

        console.log('Download: started')
      })
      .catch(e =>{
        console.info('Download: error')
        console.error(e)

        $this.setState({
          transfer_loading : false
        })
      })
  }

  update_metrics() {

    let $this = this

    let today = new Date()
    let year = today.getFullYear()
    let  month = today.getMonth()

    let last_month_first_day = new Date(year, month - 1, 1);
    let last_month_last_day  = new Date(year, month, 0);

    let this_month_first_day = new Date(year, month, 1);

    let last_day = new Date();
    last_day.setDate(last_day.getDate() - 1);

    $this.setState({last_24_loading : true})

    CloudFlyerAPI
      .transfer
      .summary(last_day,  today, "file_catalyst")
      .then(function (response) {
        let history     = $this.state.history
        history.last_24 = (response||{}).data
        $this.setState({history : history, last_24_loading : false})
      })
      .catch((e)=>{
        $this.setState({last_24_loading : false})
        console.error(e)
      })

    $this.setState({this_month_loading : true})
    CloudFlyerAPI
      .transfer
      .summary(this_month_first_day,  today, "file_catalyst")
      .then(function (response) {
        let history        = $this.state.history
        history.this_month = (response||{}).data
        $this.setState({history : history, this_month_loading : false})
      })
      .catch((e)=>{
        $this.setState({this_month_loading : false})
        console.error(e)
      })

    $this.setState({last_month_loading:true})
    CloudFlyerAPI
      .transfer
      .summary(last_month_first_day,  last_month_last_day, "file_catalyst")
      .then(function (response) {
        let history        = $this.state.history
        history.last_month = (response||{}).data
        $this.setState({history : history, last_month_loading:false})
      })
      .catch((e)=>{
        $this.setState({last_month_loading:false})
        console.error(e)
      })
  }

  on_acl_change = acl => this.setState({access_control:acl})

  on_launch_transfer_agent = ()=> {
    this.setState({
      launch_attempt: this.state.launch_attempt++,
      launch_loading : true
    })

    CloudFlyerAPI
      .file_catalyst
      .transfer_agent
      .launch()
      .then(()=> this.heartbeat(0))
  }

  heartbeat = timeout => {
    let $this = this
    setTimeout(()=> {
      CloudFlyerAPI
        .file_catalyst
        .transfer_agent
        .heartbeat()
        .then(() =>{
          if(!$this.state.is_transfer_agent_running){
            $this.setState({
              is_transfer_agent_running : true,
              launch_loading            : false
            }, ()=> $this.connect_to_server(()=>$this.heartbeat(0)))
          } else {
            $this.setState({
              launch_loading : false
            }, ()=> $this.heartbeat())
          }
        })
        .catch(e =>{
          console.info('TA: stopped')

          if($this.state.is_transfer_agent_running){
            $this.setState({
              is_transfer_agent_running : false,
              launch_loading            : false
            }, () => $this.heartbeat())
          } else if($this.state.launch_attempt) {
            $this.setState({launch_loading : false}, ()=> $this.heartbeat())
          } else {
            $this.setState({launch_loading : false}, ()=> console.info('TA: no launch attempt'))
          }
        })
    },timeout ? timeout : $this.state.heartbeat)
  }

  connect_to_server = (on_run, on_error) =>{
    let $this = this
    if(!$this.state.is_transfer_agent_running){
      return $this.setState({
        transfer_server_error : 'Transfer agent is not running',
        connection_key        : null
      }, ()=> on_error ? on_error({message : 'Transfer agent is not running'}) : null)
    }

    if(!$this.props.user.file_catalyst_password){
      message.error('Files transfers are not activated for this user')
      $this.props.refresh_profile()
      return on_error ? on_error({message : 'Files transfers are not activated for this user'}) : null
    }

    CloudFlyerAPI
      .file_catalyst
      .transfer_agent
      .connect(FC_HOST, FC_PORT, $this.props.user.file_catalyst_id, $this.props.user.file_catalyst_password)
      .then(res =>{
        $this.setState({
          transfer_server_error     : null,
          connection_key            : ((res||{}).data||{}).connectionKey
        }, ()=> on_run ? on_run(((res||{}).data||{}).connectionKey) : null)
      })
      .catch(e =>{
        console.info('TS: stopped')
        $this.setState({
          transfer_server_error     : ((e.response||{}).data && (e.response||{}).data.reason) ? (e.response||{}).data.reason.text :  e.response.statusText,
          connection_key            : null
        }, ()=> on_error ? on_error(e) : null)
      })
  }

  render () {
    let { is_transfer_agent_running, connection_key, transfer_server_error, launch_loading,
      transfer_loading, upload_selection, download_selection, access_control,
      last_24_loading, this_month_loading, last_month_loading } = this.state
    return (
      <Tabs defaultActiveKey="1" className='fc noselect'>
        <Tabs.TabPane tab="CloudFlyer Transfer" key="1">
          <Container fluid>

            <Row className='header-row'>
              {
                (!is_transfer_agent_running) ?
                  <Launcher on_launch={this.on_launch_transfer_agent} loading={launch_loading}/> : ''
              }
            </Row>

            <Row className='header-sub-row'>
              <Col md={6} className={'left-indicators'}>
                <UploadSize size={upload_selection.size}/>
                <CostPerMb cost={upload_selection.cost}/>
                <UploadCost cost={upload_selection.total_cost}/>
                <AccessControl access_control={access_control} onChange={this.on_acl_change.bind(this)} disabled={true}/>
              </Col>

              <Col md={6} className={'right-indicators'}>
                <DownloadSize size={download_selection.size}/>
                <CostPerMb cost={download_selection.cost}/>
                <DownloadCost cost={download_selection.total_cost}/>
              </Col>
            </Row>

            <Row className='content-row'>
              <Col md={6}>
                <LocalFiles is_transfer_agent_running = {is_transfer_agent_running}
                            transfer_server_error     = {transfer_server_error}
                            connection_key            = {connection_key}
                            access_control            = {access_control}
                            launch_loading            = {launch_loading}
                            on_launch_transfer_agent  = {this.on_launch_transfer_agent.bind(this)}/>
              </Col>

              <Col md={6}>
                <CloudFilesSystem
                  title={'Cloud File System'}
                  state          = {'fc'}
                  on_download    = {this.on_download.bind(this)}
                  use_weblink    = {true}
                  connection_key = {connection_key}
                  block_ui       = {transfer_loading}/>
              </Col>
            </Row>

            <Row className='content-row'>
              <Col md={12}>
                <FilesTransfers
                  is_transfer_agent_running ={is_transfer_agent_running}
                  transfer_server_error     ={transfer_server_error}
                  connection_key            ={connection_key}
                  on_retry                  ={()=> this.connect_to_server()}/>
              </Col>
            </Row>

          </Container>
        </Tabs.TabPane>

        <Tabs.TabPane tab="Transfer History" key="2">
          <Container fluid>
            <Row className='header-row'>

              <Col md={4}>
                <Last24 history={this.state.history.last_24} loading={last_24_loading}/>
              </Col>

              <Col md={4}>
                <ThisMonth history={this.state.history.this_month} loading={this_month_loading}/>
              </Col>

              <Col md={4}>
                <LastMonth history={this.state.history.last_month} loading={last_month_loading}/>
              </Col>
            </Row>

            <Row className='content-row'>
              <Col md={12}>
                <TransfersHistory/>
              </Col>
            </Row>
          </Container>
        </Tabs.TabPane>
      </Tabs>
    )
  }
}

export default withRouter(connect(({auth, fileCatalyst, s3Direct }) => {
  let local_current_path = '/'
  if(fileCatalyst){
    if(fileCatalyst.current_path && typeof fileCatalyst.current_path === 'string' && fileCatalyst.current_path.length > 0 && fileCatalyst.current_path.startsWith('/')){
      local_current_path = fileCatalyst.current_path
    } else {
      local_current_path = '/' + fileCatalyst.current_path
    }
  }

  return {
    user               : auth.user,
    upload_selection   : fileCatalyst.selection,
    download_selection : s3Direct.cloud_selection,
    local_current_path
  }
}, (dispatch) => bindActionCreators({refresh_profile: refresh_profile}, dispatch))(FileCatalyst))
